import styled from "styled-components";

export const PreviewWrapper = styled.section`
  flex-basis: 50%;
  border-left: 3px solid lightgray;
  @media screen and (max-width: 768px) {
    border: none;
  }
`;

export const SectionTitle = styled.h1`
  padding: 2rem;
  text-align: center;
  font-size: 4.2rem;
`;
